<template>
    <div id="register-area">

        <div @click="show(1)" class="register-select" style="margin-left: 0px">
            <p>{{area.selectProvinceName}}</p>
            <VuePicker :data="provinces"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="provincesPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div @click="show(2)" class="register-select">
            <p>{{area.selectCityName}}</p>
            <VuePicker :data="cities"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="citiesPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div @click="show(3)" class="register-select">
            <p>{{area.selectAreaName}}</p>
            <VuePicker :data="areas"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="areasPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div style="clear:both;"></div>
    </div>
</template>

<script>
    import {GetProvinceList, GetCityList, GetZoneList} from "../api/City";
    import VuePicker from 'vue-pickers'

    var provincesData = [];
    var citiesData = [];
    var areasData = [];


    export default {
        name: "AreaComponents",

        props: ['provinceProps', 'cityProps', 'areaProps'],

        components: {
            VuePicker
        },

        data() {
            return {
                area: {
                    selectProvince: '',
                    selectCity: '',
                    selectArea: '',
                    selectProvinceName: '请选择',
                    selectCityName: '请选择',
                    selectAreaName: '请选择',
                },

                provincesPickerVisible: false,
                citiesPickerVisible: false,
                areasPickerVisible: false,

                provinces: [
                    provincesData
                ],

                cities: [
                    citiesData
                ],

                areas: [
                    areasData
                ]
            }
        },

        mounted() {
            this.getProvinceList()
        },

        methods: {

            show (value) {
                if (value === 1) {
                    this.provincesPickerVisible = true
                } else if (value === 2) {
                    if (citiesData.length !== 0) {
                        this.citiesPickerVisible = true
                    } else {
                        this.citiesPickerVisible = false
                    }
                } else {
                    if (areasData.length !== 0) {
                        this.areasPickerVisible = true
                    } else {
                        this.areasPickerVisible = false
                    }
                }
            },

            cancel () {
                this.result = 'click cancel result: null'
            },

            confirm (res) {
                let _this = this;
                if (this.provincesPickerVisible) {
                    _this.area.selectProvince = res[0].value;
                    _this.area.selectProvinceName = res[0].label;
                    _this.area.selectCityName = '请选择';
                    _this.area.selectAreaName = '请选择';
                    _this.getCityList(_this.area.selectProvince);
                } else if (this.citiesPickerVisible) {
                    _this.area.selectCity = res[0].value;
                    _this.area.selectCityName = res[0].label;
                    _this.area.selectAreaName = '请选择';
                    _this.getZoneList(_this.area.selectCity);
                } else {
                    _this.area.selectArea = res[0].value;
                    _this.area.selectAreaName = res[0].label
                }

                setTimeout(function () {
                    _this.$emit("selectArea", _this.area.selectProvinceName, _this.area.selectCityName, _this.area.selectAreaName)
                }, 10);


            },

            getProvinceList() {
                this.provinces = [
                    provincesData = [],
                ];

                GetProvinceList().then(response => {
                    response.data.forEach((item) => {
                        provincesData.push({
                            value: item.id,
                            label: item.provincialName,
                        })
                    })
                })
            },

            getCityList(provinceId) {
                this.cities = [
                    citiesData = [],
                ];
                GetCityList(provinceId).then(response => {
                    response.data.forEach((item) => {
                        citiesData.push({
                            value: item.id,
                            label: item.cityName,
                        })
                    })
                })
            },

            getZoneList(cityId) {
                this.areas = [
                    areasData = [],
                ];
                GetZoneList(cityId).then(response => {
                    response.data.forEach((item) => {
                        areasData.push({
                            value: item.id,
                            label: item.cityName,
                        })
                    })
                })
            }
        },

        watch: {
            provinceProps:{
                handler(value) {
                    this.area.selectProvinceName = value;
                }

            },
            cityProps:{
                handler(value) {
                    this.area.selectCityName = value;
                }
            },
            areaProps:{
                handler(value) {
                    this.area.selectAreaName = value;
                }
            },
        }
    }
</script>

<style lang="scss">
    #register-area {
        width: auto;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 20px;

        .register-select {
            width: 32%;
            height: 35px;
            background-color: white;
            border-radius: 5px;
            border: 2px solid #ffa9af;
            line-height: 5px;
            margin-left: 5px;
            float: left;
            position: relative;

            p {
                position: absolute;
                width: 100%;
            }
        }

        img {
            width: 13px;
            height: 8px;
            position: absolute;
            right: 5px;
            top: 12px;
        }

    }

    .btn {
        font-size: 1rem !important;
        border: none !important;
        padding: 10px 30px !important;
    }
</style>